import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { useUpdateTag } from 'entities/tag';

interface SignSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentSignValue: string | null;
  disabled?: boolean;
}

export const SignSwitch = ({ tagId, documentSuperId, currentSignValue, disabled = false }: SignSwitchProps) => {
  const { t } = useTranslation('tag');

  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (isNegative: boolean) => {
    updateTag({
      id: tagId,
      documentSuperId,
      sign: isNegative ? '-' : null,
    });
  };

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {t('sign.title')}
      </Typography>
      <Form.Check
        type="switch"
        id={`sign-switch-${tagId}`}
        checked={currentSignValue === '-'}
        onChange={(e) => handleUpdate(e.target.checked)}
        disabled={disabled}
        style={disabled ? { cursor: 'not-allowed' } : undefined}
      />
    </div>
  );
};
